import {
  Box,
  Image
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { v4 as uuid } from 'uuid'

export const GuestContentItem = ({
  items,
  title
}) => {
  if (!items.length) {
    return <div>No notifications to display</div>
  }

  return (
    <>
      {[...items].reverse().map((item) => (
        <Box
          key={uuid()}
          cursor="pointer"
          onClick={() => {
            if (title === 'connector') {
              window.open(item?.link)
            } else {
              console.log(' ')
            }
          }}
          onLoad={() => {
            if (localStorage.getItem('openedNotifId') === String(item?.id)) {
              localStorage.removeItem('openedNotifId')
            }
          }}
          sx={{
            minWidth: '120px',
            marginTop: '5px'
          }}
          data-name="notificationItem"
        >
          <Image
            width="108px"
            height="108px"
            objectFit="cover"
            src={item?.image || ImagesPng.DefaultImage}
            alt={item?.title}
            borderRadius="5px"
          />
        </Box>
      ))}
    </>
  )
}
